import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { DateFormatService } from '../services/date-format.service';

@Pipe({
  name: 'customDate',
  standalone: false
})
export class CustomDatePipe implements PipeTransform {
  constructor(
    private dateFormatService: DateFormatService,
    private datePipe: DatePipe
  ) {}

  transform(value: any, _trigger?: string): any {
    const format = this.dateFormatService.currentDateFormatValue;
    return this.datePipe.transform(value, format);
  }
}

@Pipe({
  name: 'customDateTime',
  standalone: false
})
export class CustomDateTimePipe implements PipeTransform {
  constructor(
    private dateFormatService: DateFormatService,
    private datePipe: DatePipe
  ) {}

  transform(value: any, _trigger?: string): any {
    const format = this.dateFormatService.currentDateTimeFormatValue;
    return this.datePipe.transform(value, format);
  }
}

@Pipe({
  name: 'birDate',
  standalone: false,
  pure: true
})
export class BirDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: any): any {
    return this.datePipe.transform(value, 'MM/dd/yyyy');
  }
}

@Pipe({
  name: 'birDateTime',
  standalone: false,
  pure: true
})
export class BirDateTimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: any): any {
    return this.datePipe.transform(value, 'MM/dd/yyyy hh:mm:ss a');
  }
}
